import {FaRegCopy} from "react-icons/fa6";
import cookies from 'js-cookie'
import React, {useCallback, useEffect, useMemo, useRef, useState} from "react";

import {FaRegNewspaper} from "react-icons/fa6";
import {
    Alert,
    Avatar,
    Button,
    Card,
    Cascader, Checkbox, Collapse,
    ConfigProvider,
    Divider, Drawer, Empty,
    Dropdown,
    Flex, FloatButton,
    Form,
    Grid,
    Input, InputRef,
    Layout,
    Menu,
    MenuProps,
    message,
    Modal, Popconfirm, Popover, Radio,
    Select, Space, Tabs, Tag, Typography, Watermark
} from "antd";
import dayjs from "dayjs";

import axios from 'axios';
import {Outlet, useLocation, useNavigate} from "react-router-dom";
import Cookies from "js-cookie";
import copy from "copy-to-clipboard";
import {CiEdit} from "react-icons/ci";
import {MdOutlineAdd} from "react-icons/md";

import {MdFormatListBulletedAdd} from "react-icons/md";

import {
    AppstoreOutlined,
    CloudUploadOutlined,
    DatabaseOutlined,
    FileAddOutlined,
    FileTextOutlined,
    KeyOutlined,
    MenuFoldOutlined,
    MenuUnfoldOutlined,
    MessageOutlined,
    BgColorsOutlined,
    SearchOutlined,
    SettingOutlined,
    UserOutlined,
} from "@ant-design/icons";
import { ADMIN_API, COMMON_API, EMPLOYEE_API } from '../config/api';

import './technologyShell.css';

import Search_ui_index from "./Admin_search";
import BuyVip_ui from "./BuyVip";
import BuyVip_modal_ui from "./BuyVip/index_modal";
import SearchChain from "./Admin_kuai_message";

const {Header, Content, Sider} = Layout;
const {useBreakpoint} = Grid;

const CHAT_PAGE_TITLES: Record<string, string> = {
    '/admin/keyclick': '快捷键',
    '/admin/users': '客户管理',
    '/admin/account': '账户额度',
    '/admin/kuai_message': '快捷话术',
    '/admin/commodity_fenlei': '商品分类',
    '/admin/commodity_list': '商品',
    '/admin/detail': '知识库',
    '/admin/search': '快捷搜索',
    '/admin/moban': '模板',
    '/admin/client_update': '客户端管理',
    '/admin/setting': '设置',
};

const chatMenuItems: MenuProps['items'] = [
    {key: '/admin/keyclick', icon: <KeyOutlined/>, label: '快捷键'},
    {key: '/admin/users', icon: <UserOutlined/>, label: '客户管理'},
    {key: '/admin/account', icon: <UserOutlined/>, label: '账户额度'},
    {key: '/admin/kuai_message', icon: <MessageOutlined/>, label: '快捷话术'},
    {
        key: 'sub_commodity',
        icon: <AppstoreOutlined/>,
        label: '商品列表',
        children: [
            {key: '/admin/commodity_fenlei', label: '分类'},
            {key: '/admin/commodity_list', label: '商品'},
        ],
    },
    {key: '/admin/detail', icon: <DatabaseOutlined/>, label: '知识库'},
    {key: '/admin/search', icon: <SearchOutlined/>, label: '快捷搜索'},
    {key: '/admin/moban', icon: <FileTextOutlined/>, label: '模板'},
    {key: '/admin/client_update', icon: <CloudUploadOutlined/>, label: '客户端管理'},
    {key: '/admin/setting', icon: <SettingOutlined/>, label: '设置'},
];

const ADMIN_ROLE_PAGES = [
    '/admin/account','/admin/keyclick','/admin/kuai_message','/admin/commodity_fenlei',
    '/admin/commodity_list','/admin/detail','/admin/search','/admin/moban',
    '/admin/client_update','/admin/setting',
];
const USER_ROLE_PAGES = ['/admin/account','/admin/keyclick','/admin/kuai_message','/admin/search','/admin/setting'];


const Admin_Index_UI = () => {

    const location = useLocation();
    const [accountRole, setAccountRole] = useState('user');
    const [accountProfileLoading, setAccountProfileLoading] = useState(true);
    const [visiblePages, setVisiblePages] = useState<string[] | null>(null);
    const [themeColor, setThemeColor] = useState(() => localStorage.getItem('chattool_admin_theme') || '#7c3aed');

    useEffect(() => {
        const body = new FormData();
        body.append('userToken', String(Cookies.get('userToken_chattool') || ''));
        body.append('action', 'profile');
        fetch('https://chatv2.leytcn.com/api/admin/account_management/account_manage.php', {method: 'POST', body})
            .then(response => response.json())
            .then(data => {
                if (data.message !== 2000) return;
                setAccountRole(data.info?.role || 'user');
                try { setVisiblePages(data.info?.visible_pages_json ? JSON.parse(data.info.visible_pages_json) : null); }
                catch { setVisiblePages(null); }
            })
            .catch(() => setAccountRole('user'))
            .finally(() => setAccountProfileLoading(false));
    }, []);

    const rolePageKeys=useMemo(()=>accountRole==='super_admin'?null:accountRole==='admin'?ADMIN_ROLE_PAGES:USER_ROLE_PAGES,[accountRole]);

    const visibleChatMenuItems = useMemo(() => {
        const filterItems = (items: MenuProps['items']): MenuProps['items'] => (items || []).flatMap((item:any) => {
            if (!item || typeof item !== 'object') return [item];
            const key=String(item.key || '');
            if (key === '/admin/users' && accountRole !== 'super_admin') return [];
            if (item.children) {
                const children=filterItems(item.children);
                return children && children.length ? [{...item,children}] : [];
            }
            if (key.startsWith('/admin/') && rolePageKeys && !rolePageKeys.includes(key)) return [];
            if (key.startsWith('/admin/') && accountRole !== 'super_admin' && visiblePages && !visiblePages.includes(key)) return [];
            return [item];
        });
        return filterItems(chatMenuItems);
    }, [accountRole, rolePageKeys, visiblePages]);
    const nativeContextMenuItems = useMemo<MenuProps['items']>(() => {
        const withNativeLinks = (items: MenuProps['items']): MenuProps['items'] => (items || []).map((item:any) => {
            if (!item || typeof item !== 'object') return item;
            if (item.children) return {...item, children: withNativeLinks(item.children)};
            const href=String(item.key || '');
            return href.startsWith('/admin/') ? {...item,label:<a href={href} onClick={event=>event.preventDefault()}>{item.label}</a>} : item;
        });
        return withNativeLinks(visibleChatMenuItems);
    }, [visibleChatMenuItems]);

    const changeThemeColor = (color: string) => {
        setThemeColor(color);
        localStorage.setItem('chattool_admin_theme', color);
    };


    const [re_cookie, setre_cookie] = useState({message: '', time: 0})

    const navigate = useNavigate();

    const data_time=dayjs().unix();

    useEffect(() => {
        const usecookie = () => {


            if (Cookies.get('group') !== 'admin') {

                message.error('无访问权限')
                navigate('/login?return_url=/admin')


            } else {


                switch (Cookies.get('userToken_chattool')) {

                    case undefined:

                        navigate('/login?return_url=/admin')


                        break;

                    default:


                        let data_time = dayjs().unix();
                        setget_country_info_select_log({message:'1',value:'',time:data_time})
                        /*        setget_usermessage_select_log({message: '首次运行', value: '', time: data_time})
        */

                        break;


                }

            }
        }

        usecookie();
    }, []); // 空数组表示仅在组件挂载时执行


    const [use_message_return, setuser_message_requset_returen] = useState({user_oname: '', group_name: ''});
    const post_data_usermess = new FormData();
    post_data_usermess.append('user_token', String(Cookies.get('userToken_chattool')));


    const [get_usermessage_select_log, setget_usermessage_select_log] = useState({message: '', time: 2, value: ''})


    useEffect(() => {


        const user_message = async () => {

            const use_message_await = await fetch(`${COMMON_API.myinfo.usermessage}`, {


                method: 'POST',
                body: post_data_usermess
            });

            const data_mee = await use_message_await.json();

            setuser_message_requset_returen(data_mee);


        }

        if (get_usermessage_select_log.message !== '') {


            user_message();
            setget_usermessage_select_log({message: '', value: '', time: 0})

            console.log(use_message_return);


        } else {


        }


    }, [get_usermessage_select_log]);


    const Admin_log_out = () => {


        Cookies.remove('userToken_chattool')
        Cookies.remove('group')
        let time = dayjs().unix();
        navigate('/login')

        return (
            console.log("111")

        );


    }

    const [menu_click_value, setmenu_click_value] = useState({key: '', keyPath: []})
    const menu_click = (e: any) => {

        console.log('menu_onchange_msg, e')

        setmenu_click_value(e)


    }


    const menu_onSelect = (e: any) => {

        console.log(e)


    }


    console.log('admin')

    let cookie_info_userToken = cookies.get('userToken_chattool')


    console.log(cookie_info_userToken)


    const screens = useBreakpoint();
    const isMobile = !screens.lg;
    const [collapsed, setCollapsed] = useState(false);
    const [drawerOpen, setDrawerOpen] = useState(false);

    useEffect(() => {
        setDrawerOpen(false);
    }, [location.pathname]);

    useEffect(() => {
        if (isMobile) {
            setCollapsed(false);
        }
    }, [isMobile]);



    const [get_country_info_modal_open, setget_country_info_modal_open] = useState(false)



    const [get_country_info_select_info, setget_country_info_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [get_country_info_select_log, setget_country_info_select_log] = useState({message: '', value: '', time: 0})
    const get_country_info = (e1: any) => {

        setget_country_info_select_log({message: 'click', value: '', time: data_time})



        setget_country_info_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const [return_data_get_country_info,setreturn_data_get_country_info]=useState({});

    const get_country_info_body = new FormData();


    get_country_info_body.append('id', get_country_info_select_info.value1);

    get_country_info_body.append('userToken', String(Cookies.get('userToken_chattool')));

    get_country_info_body.append('time', String(get_country_info_select_info.time));

    get_country_info_body.append('action', 'fetch_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch(`${COMMON_API.myinfo.check_country}`, {


                method: 'POST',
                body: get_country_info_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:

                    //获取消息，无需提示
                    /* message.success(return_data.value)*/
                    let data_time = dayjs().unix();

                    setreturn_data_get_country_info(return_data);

                    //    setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    /*  message.error(return_data.value)*/
                    setcreatd_country_modal_open(false)



                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break


            }

        }


        if(get_country_info_select_log.message!==''){

            data_async();
            setget_country_info_select_log({message:'',value:'',time:0})
        }
    }, [get_country_info_select_log]);



    const [creatd_country_modal_open, setcreatd_country_modal_open] = useState(false)

    const [creatd_country_select_info, setcreatd_country_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [creatd_country_select_log, setcreatd_country_select_log] = useState({message: '', value: '', time: 0})
    const creatd_country = (e1: any) => {

        setcreatd_country_select_log({message: 'click', value: '', time: data_time})

        setcreatd_country_modal_open(false);

        setcreatd_country_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const setcreatd_country_modal_oncancel = () => {

        setcreatd_country_modal_open(false);
    }


    const [creatd_country_modal_form]=Form.useForm();

    const creatd_country_modal_initialValues={




    }

    const [creatd_country_modal_onfinish_select_log,setcreatd_country_modal_onfinish_select_log]=useState({message:'',value:'',time:0})

    const [creatd_country_modal_onfinish_select_info,setcreatd_country_modal_onfinish_select_info]=useState({value1:'',value2:'',value3:'',time:0});

    const creatd_country_modal_onfinish = (e1:any) => {

        let data_time=dayjs().unix();

        setcreatd_country_modal_onfinish_select_log({message:'next_button',value:'',time:data_time})
        setcreatd_country_modal_onfinish_select_info({value1:e1,value2:'',value3:'',time:data_time})
    }


    const [return_data_creatd_country,setreturn_data_creatd_country]=useState({});

    const creatd_country_body = new FormData();


    creatd_country_body.append('finish_data', JSON.stringify(creatd_country_modal_onfinish_select_info.value1));

    creatd_country_body.append('userToken', String(Cookies.get('userToken_chattool')));

    creatd_country_body.append('time', String(creatd_country_modal_onfinish_select_info.time));

    creatd_country_body.append('action', 'add_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch(`${ADMIN_API.country.insert}/created_country.php`, {


                method: 'POST',
                body: creatd_country_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setcreatd_country_modal_open(false)

                    setreturn_data_creatd_country(return_data);
                    //   setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break


            }

        }


        if(creatd_country_modal_onfinish_select_log.message!==''){

            data_async();
            setcreatd_country_modal_onfinish_select_log({message:'',value:'',time:0})
        }
    }, [creatd_country_modal_onfinish_select_log]);



    const [show_myvip_modal_open, setshow_myvip_modal_open] = useState(false)

    const [show_myvip_select_info, setshow_myvip_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [show_myvip_select_log, setshow_myvip_select_log] = useState({message: '', value: '', time: 0})
    const show_myvip = (e1: any) => {


        setget_products_select_log({message:'d',value:'',time:data_time})
        setfetch_vipinfo_select_log({message:'1',value:'',time:data_time})

        setfetch_select_price_info_select_log({message:'1',value:'',time:data_time})


        setshow_myvip_select_log({message: 'click', value: '', time: data_time})

        setshow_myvip_modal_open(true);

        setshow_myvip_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const setshow_myvip_modal_oncancel = () => {

        setshow_myvip_modal_open(false);
    }


    const [show_myvip_modal_next_button_select_log,setshow_myvip_modal_next_button_select_log]=useState({message:'',value:'',time:0})

    const show_myvip_modal_next_button = () => {

        let data_time=dayjs().unix();

        setshow_myvip_modal_next_button_select_log({message:'next_button',value:'',time:data_time})

    }


    const [return_data_show_myvip,setreturn_data_show_myvip]=useState({});

    const show_myvip_body = new FormData();


    show_myvip_body.append('id', show_myvip_select_info.value1);

    show_myvip_body.append('userToken', String(Cookies.get('userToken_chattool')));

    show_myvip_body.append('time', String(show_myvip_modal_next_button_select_log.time));

    show_myvip_body.append('action', 'del_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('undefined', {


                method: 'POST',
                body: show_myvip_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setshow_myvip_modal_open(false)

                    setreturn_data_show_myvip(return_data);
                    //   setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break

            }

        }


        if(show_myvip_modal_next_button_select_log.message!==''){

            data_async();
            setshow_myvip_modal_next_button_select_log({message:'',value:'',time:0})
        }
    }, [show_myvip_modal_next_button_select_log]);





    const [onekey_create_dv_country_select_info, setonekey_create_dv_country_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [onekey_create_dv_country_select_log, setonekey_create_dv_country_select_log] = useState({message: '', value: '', time: 0})
    const onekey_create_dv_country = (e1: any) => {

        setonekey_create_dv_country_select_log({message: 'click', value: '', time: data_time})



        setonekey_create_dv_country_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const [return_data_onekey_create_dv_country,setreturn_data_onekey_create_dv_country]=useState({});

    const onekey_create_dv_country_body = new FormData();


    onekey_create_dv_country_body.append('id', onekey_create_dv_country_select_info.value1);

    onekey_create_dv_country_body.append('userToken', String(Cookies.get('userToken_chattool')));

    onekey_create_dv_country_body.append('time', String(onekey_create_dv_country_select_info.time));

    onekey_create_dv_country_body.append('action', 'add_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch(`${ADMIN_API.country.insert}/onekey_create_dv_country.php`, {


                method: 'POST',
                body: onekey_create_dv_country_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    /* message.success(return_data.value)*/
                    let data_time = dayjs().unix();
                    setcreatd_country_modal_open(false)
                    setreturn_data_onekey_create_dv_country(return_data);

                    //setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break


            }

        }


        if(onekey_create_dv_country_select_log.message!==''){

            data_async();
            setonekey_create_dv_country_select_log({message:'',value:'',time:0})
        }
    }, [onekey_create_dv_country_select_log]);




    const [value, setValue] = useState('11'); // 默认选中的
    const [purchaseDuration, setPurchaseDuration] = useState('1m');
    const productMatchesDuration = (item: any, duration: string) => {
        const days = Number(item.vipday || 0);
        if (duration === 'permanent') return days === 0 || days >= 36500;
        if (duration === '1y') return days >= 360 && days < 36500;
        if (duration === '6m') return days >= 175 && days < 360;
        return days > 0 && days <= 35;
    };


    const [checkbox_buy, setcheckbox_buy] = useState(true); // 默认选中的

    const onChange = (e:any) => {
        console.log('选中的', e.target.value);
        setValue(e.target.value);
    };


    const [pay_method,setpay_method]=useState('alipay')

    const buy_onchange=(e1:any)=>{


        setValue(e1)
        setfetch_select_price_info_select_log({message: 'click', value: '', time: data_time})



        setfetch_select_price_info_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }




    const [pay_model_modal_open, setpay_model_modal_open] = useState(false)

    const [pay_model_select_info, setpay_model_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [pay_model_select_log, setpay_model_select_log] = useState({message: '', value: '', time: 0})
    const pay_model = (e1: any) => {

        window.open('https://api.jinxiaocun.leytcn.com/vendor/alipaysdk/openapi/v2/aop/test/ddd.php?key=111.00')
        setpay_model_select_log({message: 'click', value: '', time: data_time})

        setpay_model_modal_open(true);

        setpay_model_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const setpay_model_modal_oncancel = () => {

        setpay_model_modal_open(false);
    }


    const [pay_model_modal_next_button_select_log,setpay_model_modal_next_button_select_log]=useState({message:'',value:'',time:0})

    const pay_model_modal_next_button = () => {

        let data_time=dayjs().unix();
        setpay_model_modal_open(false);
        setfetch_vipinfo_select_log({message:'d',value:'',time:data_time})
        //  setpay_model_modal_next_button_select_log({message:'next_button',value:'',time:data_time})

    }


    const [return_data_pay_model,setreturn_data_pay_model]=useState({});

    const pay_model_body = new FormData();


    pay_model_body.append('id', pay_model_select_info.value1);

    pay_model_body.append('userToken', String(Cookies.get('userToken_chattool')));

    pay_model_body.append('time', String(pay_model_modal_next_button_select_log.time));

    pay_model_body.append('action', 'del_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('undefined', {


                method: 'POST',
                body: pay_model_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setpay_model_modal_open(false)

                    setreturn_data_pay_model(return_data);
                    //     setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break

            }

        }


        if(pay_model_modal_next_button_select_log.message!==''){

            data_async();
            setpay_model_modal_next_button_select_log({message:'',value:'',time:0})
        }
    }, [pay_model_modal_next_button_select_log]);


    const [buy_phone_pay_select_info, setbuy_phone_pay_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [buy_phone_pay_select_log, setbuy_phone_pay_select_log] = useState({message: '', value: '', time: 0})
    const buy_phone_pay = (e1:any,e2:any,buy_method:any) => {

        if(checkbox_buy){

            console.log('pay_method'+pay_method)

            switch (true){


                case pay_method==='wxpay':
                    message.info('暂时不支持微信支付')
                    break;

                case pay_method==='alipay':


                    setbuy_phone_pay_select_log({message: 'click', value: '', time: data_time})

                    setbuy_phone_pay_select_info({value1: e1, value2: 'default_address.uuid', value3: 'select_send_date_time_finish.value1', time: data_time})


                    break;



            }




        }else {

            message.info('请先阅读并同意条款')
        }






    }


    const [return_data_buy_phone_pay,setreturn_data_buy_phone_pay]=useState({});

    const buy_phone_pay_body = new FormData();





    buy_phone_pay_body.append('pay_node', value);

    buy_phone_pay_body.append('pay_method', pay_method);

    buy_phone_pay_body.append('id', buy_phone_pay_select_info.value1);
    buy_phone_pay_body.append('buy_method', 'alipay');


    buy_phone_pay_body.append('userToken', String(Cookies.get('userToken_chattool')));
    buy_phone_pay_body.append('day', '1');

    buy_phone_pay_body.append('time', String(buy_phone_pay_select_info.time));


    buy_phone_pay_body.append('action', 'fetch_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch(`${ADMIN_API.buyshop.insert}`, {


                method: 'POST',
                body: buy_phone_pay_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:

                    /*  message.success(return_data.value)*/
//添加成功，无需提示
                    /*    Toast.show({
                          content: return_data.value,
                          duration: 2000,
                          position: 'bottom',
                      });*/
                    let data_time = dayjs().unix();

                    setreturn_data_buy_phone_pay(return_data);

                    setpay_model_modal_open(true);

                    /*         navigate('/buyshop_next?merchant_uuid='+'merchant_uuid'+'&order_number='+return_data.info.order_number+'&buy_method='+return_data.info.buy_method+'&return_url='+String(return_url))
         */
                    // navigate('/buyshop_next?merchant_uuid='+merchant_uuid+'&order_number='+return_data.info.order_number+'&buy_method='+return_data.info.buy_method+'&return_url='+String(return_url), {replace: true})
                    //   window.location.href=('https://api.shop.leytcn.com/function_api/home/buyshop/buyalipay/buy_alipay.php?merchant_uuid='+String(Cookies.get('merchant_uuid'))+'&order_number='+String(return_data.info.order_number));

                    window.open(`${ADMIN_API.buyshop.alipay}?order_number=`+String(return_data.info.order_number))
                    // setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:
                    message.info(return_data.value)
                    /*   Toast.show({
                           content: return_data.value,
                           duration: 2000,
                           position: 'bottom',
                       });*/


                    break


                case 4018:

                    setTimeout(() => {
                        message.error(return_data.value)
                        /*      setbug_post_finish_button_loading(false);*/
                        /* Toast.show({
                             content: return_data.value,
                             duration: 2000,
                             position: 'bottom',
                         });*/
                    }, 300)

                    navigate('/login')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        /*     Toast.show({
                                 content: return_data.value,
                                 duration: 2000,
                                 position: 'bottom',
                             });*/
                    }, 300)

                    navigate('/login')


                    break


            }

        }


        if(buy_phone_pay_select_log.message!==''){

            data_async();
            setbuy_phone_pay_select_log({message:'',value:'',time:0})
        }
    }, [buy_phone_pay_select_log]);






    const [get_products_select_info, setget_products_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [get_products_select_log, setget_products_select_log] = useState({message: '', value: '', time: 0})
    const get_products = (e1: any) => {

        setget_products_select_log({message: 'click', value: '', time: data_time})



        setget_products_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const [return_data_get_products,setreturn_data_get_products]=useState({
        "message": 2000,
        "value": "获取成功",
        "info": [
            {
                "id": "1",
                "title": "聊天助手会员",
                "sub_title": "1个月使用期限",
                "price": "2.50",
                "joinCouponTotalPrice": null,
                "totalPrice": "2.50",
                "market_price": null,
                "vip_price": null,
                "barcode": null,
                "hod": null,
                "value": "1",
                "node": null,
                "uuid": "11",
                "inventory": null,
                "qualification_card_uuid": null,
                "parent_uuid": "0",
                "created": "0",
                "updated": null,
                "status": "en",
                "status_type": null,
                "images_json": null,
                "image": null,
                "region_id": null,
                "buy_max_num": null
            },
            {
                "id": "2",
                "title": "聊天助手会员",
                "sub_title": "1个年使用期限",
                "price": "30.00",
                "joinCouponTotalPrice": null,
                "totalPrice": "2.50",
                "market_price": "19.90",
                "vip_price": null,
                "barcode": null,
                "hod": null,
                "value": "1",
                "node": null,
                "uuid": "11",
                "inventory": null,
                "qualification_card_uuid": null,
                "parent_uuid": "0",
                "created": "0",
                "updated": null,
                "status": "en",
                "status_type": null,
                "images_json": null,
                "image": null,
                "region_id": null,
                "buy_max_num": null
            }
        ]
    });

    const get_products_body = new FormData();


    get_products_body.append('id', get_products_select_info.value1);

    get_products_body.append('userToken', String(Cookies.get('userToken_chattool')));

    get_products_body.append('time', String(get_products_select_info.time));

    get_products_body.append('action', 'fetch_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch(`${ADMIN_API.vip_products.fetch}/fetch_products.php`, {


                method: 'POST',
                body: get_products_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    /*message.success(return_data.value)*/
                    let data_time = dayjs().unix();

                    setreturn_data_get_products(return_data);

                    //       setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break


            }

        }


        if(get_products_select_log.message!==''){

            data_async();
            setget_products_select_log({message:'',value:'',time:0})
        }
    }, [get_products_select_log]);






    const [fetch_select_price_info_select_info, setfetch_select_price_info_select_info] = useState({value1: '11', value2: '', value3: '', time: 0})

    const [fetch_select_price_info_select_log, setfetch_select_price_info_select_log] = useState({message: '', value: '', time: 0})
    const fetch_select_price_info = (e1: any) => {

        setfetch_select_price_info_select_log({message: 'click', value: '', time: data_time})



        setfetch_select_price_info_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const [return_data_fetch_select_price_info,setreturn_data_fetch_select_price_info]=useState({
        "message": 2000,
        "value": "获取成功",
        "info": {
            "id": "1",
            "title": "聊天助手会员",
            "sub_title": "1个月使用期限",
            "price": "2.50",
            "joinCouponTotalPrice": null,
            "totalPrice": "2.50",
            "market_price": null,
            "vip_price": null,
            "barcode": null,
            "hod": null,
            "value": "1",
            "node": null,
            buy_vip_end_time:0,
            "uuid": "11",
            "inventory": null,
            "qualification_card_uuid": null,
            "parent_uuid": "0",
            "created": "0",
            "updated": null,
            "status": "en",
            "status_type": null,
            "images_json": null,
            "image": null,
            "region_id": null,
            "buy_max_num": null
        }
    });

    const fetch_select_price_info_body = new FormData();


    fetch_select_price_info_body.append('uuid', fetch_select_price_info_select_info.value1);

    fetch_select_price_info_body.append('userToken', String(Cookies.get('userToken_chattool')));

    fetch_select_price_info_body.append('time', String(fetch_select_price_info_select_info.time));

    fetch_select_price_info_body.append('action', 'fetch_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch(`${ADMIN_API.vip_products.fetch}/fetch_select_price_info.php`, {


                method: 'POST',
                body: fetch_select_price_info_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    /*message.success(return_data.value)*/
                    let data_time = dayjs().unix();

                    setreturn_data_fetch_select_price_info(return_data);

                    //   setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break


            }

        }


        if(fetch_select_price_info_select_log.message!==''){

            data_async();
            setfetch_select_price_info_select_log({message:'',value:'',time:0})
        }
    }, [fetch_select_price_info_select_log]);





    const [fetch_vipinfo_select_info, setfetch_vipinfo_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [fetch_vipinfo_select_log, setfetch_vipinfo_select_log] = useState({message: '', value: '', time: 0})
    const fetch_vipinfo = (e1: any) => {

        setfetch_vipinfo_select_log({message: 'click', value: '', time: data_time})



        setfetch_vipinfo_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const [return_data_fetch_vipinfo,setreturn_data_fetch_vipinfo]=useState({
        "message": 2000,
        "value": "获取成功",
        is_dt:0,
        "info": {
            "id": "1",
            "uuid": "1",
            "title": "1",
            "status": "en",
            "type": "专业",
            "value": "",
            "vip_end_time": 0,
            "is_del": "0",
            "country_uuid": "341eea77-f9ef-4157-a695-05c0f9b70761"
        }
    });

    const fetch_vipinfo_body = new FormData();


    fetch_vipinfo_body.append('uuid', fetch_vipinfo_select_info.value1);

    fetch_vipinfo_body.append('userToken', String(Cookies.get('userToken_chattool')));

    fetch_vipinfo_body.append('time', String(fetch_vipinfo_select_info.time));

    fetch_vipinfo_body.append('action', 'fetch_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch(`${ADMIN_API.vip_products.fetch}/fetch_vipinfo.php`, {


                method: 'POST',
                body: fetch_vipinfo_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    /* message.success(return_data.value)*/
                    let data_time = dayjs().unix();

                    setreturn_data_fetch_vipinfo(return_data);

                    // setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break


            }

        }


        if(fetch_vipinfo_select_log.message!==''){

            data_async();
            setfetch_vipinfo_select_log({message:'',value:'',time:0})
        }
    }, [fetch_vipinfo_select_log]);



    const [myuserinfo_modal_open, setmyuserinfo_modal_open] = useState(false)

    const [myuserinfo_select_info, setmyuserinfo_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [myuserinfo_select_log, setmyuserinfo_select_log] = useState({message: '', value: '', time: 0})
    const myuserinfo = (e1: any) => {


        setfetch_userinfo_select_log({message:'d',value:'',time:data_time})

        setmyuserinfo_select_log({message: 'click', value: '', time: data_time})

        setmyuserinfo_modal_open(true);

        setmyuserinfo_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const setmyuserinfo_modal_oncancel = () => {

        setmyuserinfo_modal_open(false);
    }


    const [myuserinfo_modal_form]=Form.useForm();

    const myuserinfo_modal_initialValues={




    }

    const [myuserinfo_modal_onfinish_select_log,setmyuserinfo_modal_onfinish_select_log]=useState({message:'',value:'',time:0})

    const [myuserinfo_modal_onfinish_select_info,setmyuserinfo_modal_onfinish_select_info]=useState({value1:'',value2:'',value3:'',time:0});

    const myuserinfo_modal_onfinish = (e1:any) => {

        let data_time=dayjs().unix();

        setmyuserinfo_modal_onfinish_select_log({message:'next_button',value:'',time:data_time})
        setmyuserinfo_modal_onfinish_select_info({value1:e1,value2:'',value3:'',time:data_time})
    }


    const [return_data_myuserinfo,setreturn_data_myuserinfo]=useState({});

    const myuserinfo_body = new FormData();


    myuserinfo_body.append('finish_data', JSON.stringify(myuserinfo_modal_onfinish_select_info.value1));

    myuserinfo_body.append('userToken', String(Cookies.get('userToken_codegenerate')));

    myuserinfo_body.append('time', String(myuserinfo_modal_onfinish_select_info.time));

    myuserinfo_body.append('action', 'add_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('undefined', {


                method: 'POST',
                body: myuserinfo_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setmyuserinfo_modal_open(false)

                    setreturn_data_myuserinfo(return_data);
                    //   setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break


            }

        }


        if(myuserinfo_modal_onfinish_select_log.message!==''){

            data_async();
            setmyuserinfo_modal_onfinish_select_log({message:'',value:'',time:0})
        }
    }, [myuserinfo_modal_onfinish_select_log]);



    const pay_type_onchange=(e1:any)=>{


        setpay_method(e1.target.value)
        console.log(e1.target.value)
    }

    const accountDropdownItems: MenuProps['items']=[{
        key: '1',onClick:show_myvip,
        label: (
            <div style={{width:70}}>


                <label >
                    我的vip
                </label>
            </div>
        ),
    },
        {
            key: '2', onClick:()=>navigate('/admin/account?edit_profile=1'),
            label: (
                <div style={{width:96}}>
                    <label >
                        修改个人资料
                    </label>
                </div>
            ),
        },
        ...(accountRole === 'super_admin' ? [{
            key: 'users', onClick:()=>navigate('/admin/users'),
            label: <div style={{width:96}}>用户管理</div>,
        }] : []),
        {
            key: '3',onClick:Admin_log_out,
            label: (
                <div style={{width:70}}>
                    <label   >
                        退出登录
                    </label>
                </div>
            ),
        }]



    //兑换vip

    const [check_card_info_modal_open, setcheck_card_info_modal_open] = useState(false)

    const [check_card_info_select_info, setcheck_card_info_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [check_card_info_select_log, setcheck_card_info_select_log] = useState({message: '', value: '', time: 0})
    const check_card_info = (e1: any) => {

        const value = inputRef.current?.input?.value;


        console.log('dd')
        console.log(value+'ddd')
        if(value===''){

            message.error('请输入卡密')

        }else {

            setcheck_card_info_select_log({message: 'click', value: '', time: data_time})



            setcheck_card_info_select_info({value1: String(value), value2: '', value3: '', time: data_time})

            setcheck_card_info_modal_open(true);

        }



    }

    const setcheck_card_info_modal_oncancel = () => {

        setcheck_card_info_modal_open(false);
    }

    const [return_data_check_card_info,setreturn_data_check_card_info]=useState(
        {
            "message": 0,
            "value": "获取成功",
            "info": {
                "tips": "未使用",
                "value": "30天vip",
                "vipday": "30",
                "cardname": "1月vip",
                "card_start_time": 0,
                "card_end_time": 0,
                "card_use": false
            }


        });

    const check_card_info_body = new FormData();


    check_card_info_body.append('key_cdk', check_card_info_select_info.value1);

    check_card_info_body.append('userToken', String(Cookies.get('userToken_chattool')));

    check_card_info_body.append('time', String(check_card_info_select_info.time));

    check_card_info_body.append('action', 'fetch_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch(`${ADMIN_API.vipcard.fetch}/check_vipcard.php`, {


                method: 'POST',
                body: check_card_info_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    /*   message.success(return_data.value)*/
                    let data_time = dayjs().unix();

                    setreturn_data_check_card_info(return_data);

                    //setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    /* message.error(return_data.value)*/


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break


            }

        }


        if(check_card_info_select_log.message!==''){

            data_async();
            setcheck_card_info_select_log({message:'',value:'',time:0})
        }
    }, [check_card_info_select_log]);





    const [VipRedemption_check_card_select_info, setVipRedemption_check_card_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [VipRedemption_check_card_select_log, setVipRedemption_check_card_select_log] = useState({message: '', value: '', time: 0})
    const VipRedemption_check_card = (e1: any) => {
        const value = inputRef.current?.input?.value;

        if(value===''){

            message.error('请输入卡密')

        }else {

            setVipRedemption_check_card_select_log({message: 'click', value: '', time: data_time})


            setVipRedemption_check_card_select_info({value1: String(value), value2: '', value3: '', time: data_time})


        }
    }


    const [return_data_VipRedemption_check_card,setreturn_data_VipRedemption_check_card]=useState({});

    const VipRedemption_check_card_body = new FormData();


    VipRedemption_check_card_body.append('key_cdk', VipRedemption_check_card_select_info.value1);

    VipRedemption_check_card_body.append('userToken', String(Cookies.get('userToken_chattool')));

    VipRedemption_check_card_body.append('time', String(VipRedemption_check_card_select_info.time));

    VipRedemption_check_card_body.append('action', 'fetch_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch(`${ADMIN_API.vipcard.fetch}/check_vipcard.php`, {


                method: 'POST',
                body: VipRedemption_check_card_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:



                    if(!return_data.info.card_use){


                        const value = inputRef.current?.input?.value;
                        /*    message.success(return_data.value)*/
                        let data_time = dayjs().unix();
                        setVipRedemption_select_log({message: 'click', value: '', time: data_time})

                        setVipRedemption_modal_open(true);

                        setVipRedemption_select_info({value1: String(value), value2: '', value3: '', time: data_time})

                    }else{


                        message.error(return_data.value)
                    }
                    setreturn_data_VipRedemption_check_card(return_data);

                    // setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break


            }

        }


        if(VipRedemption_check_card_select_log.message!==''){

            data_async();
            setVipRedemption_check_card_select_log({message:'',value:'',time:0})
        }
    }, [VipRedemption_check_card_select_log]);


    const inputRef=useRef<InputRef>(null);

    const [VipRedemption_modal_open, setVipRedemption_modal_open] = useState(false)

    const [VipRedemption_select_info, setVipRedemption_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [VipRedemption_select_log, setVipRedemption_select_log] = useState({message: '', value: '', time: 0})
    const VipRedemption = (e1: any) => {


        const value = inputRef.current?.input?.value;

        if(value===''){

            message.error('请输入卡密')

        }else{

            setVipRedemption_select_log({message: 'click', value: '', time: data_time})

            setVipRedemption_modal_open(true);

            setVipRedemption_select_info({value1: String(value), value2: '', value3: '', time: data_time})
        }


    }


    const setVipRedemption_modal_oncancel = () => {

        setVipRedemption_modal_open(false);
    }


    const [VipRedemption_modal_next_button_select_log,setVipRedemption_modal_next_button_select_log]=useState({message:'',value:'',time:0})

    const VipRedemption_modal_next_button = () => {

        let data_time=dayjs().unix();

        setVipRedemption_modal_next_button_select_log({message:'next_button',value:'',time:data_time})

    }


    const [return_data_VipRedemption,setreturn_data_VipRedemption]=useState({});

    const VipRedemption_body = new FormData();


    VipRedemption_body.append('key_cdk', VipRedemption_select_info.value1);

    VipRedemption_body.append('userToken', String(Cookies.get('userToken_chattool')));

    VipRedemption_body.append('time', String(VipRedemption_modal_next_button_select_log.time));

    VipRedemption_body.append('action', 'use');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch(`${ADMIN_API.vipcard.use}/use_vipcard.php`, {


                method: 'POST',
                body: VipRedemption_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setVipRedemption_modal_open(false)

                    setreturn_data_VipRedemption(return_data);
                    //   setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})
                    setfetch_vipinfo_select_log({message:'1',value:'',time:data_time})
                    break

                case 2001:

                    message.error(return_data.value)
                    setVipRedemption_modal_open(false)

                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break

            }

        }


        if(VipRedemption_modal_next_button_select_log.message!==''){

            data_async();
            setVipRedemption_modal_next_button_select_log({message:'',value:'',time:0})
        }
    }, [VipRedemption_modal_next_button_select_log]);




    const [fetch_userinfo_select_info, setfetch_userinfo_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [fetch_userinfo_select_log, setfetch_userinfo_select_log] = useState({message: '', value: '', time: 0})
    const fetch_userinfo = (e1: any) => {

        setfetch_userinfo_select_log({message: 'click', value: '', time: data_time})



        setfetch_userinfo_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const [return_data_fetch_userinfo,setreturn_data_fetch_userinfo]=useState({

        "message": 2000,
        "value": "获取成功",
        "info": {
            "uuid": "70628e98-ac1d-44f3-a965-3dbd82376d53",
            "user_name": "aa",
            "user_group_info": "admin",
            "user_status": "en",
            "country_info": {
                "project_name": "dv",
                "country_name": "dv",
                "country_allcode": "dv",
                "is_dv": "1"
            }
        }

    });

    const fetch_userinfo_body = new FormData();


    fetch_userinfo_body.append('id', fetch_userinfo_select_info.value1);

    fetch_userinfo_body.append('userToken', String(Cookies.get('userToken_chattool')));

    fetch_userinfo_body.append('time', String(fetch_userinfo_select_info.time));

    fetch_userinfo_body.append('action', 'fetch_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch(`${ADMIN_API.myinfo.fetch}/fetch_select_userinfo.php`, {


                method: 'POST',
                body: fetch_userinfo_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    /* message.success(return_data.value)*/
                    let data_time = dayjs().unix();

                    setreturn_data_fetch_userinfo(return_data);

                    // setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break


            }

        }


        if(fetch_userinfo_select_log.message!==''){

            data_async();
            setfetch_userinfo_select_log({message:'',value:'',time:0})
        }
    }, [fetch_userinfo_select_log]);

    const chatMenuKeys = useMemo(() => {
        const keys: string[] = [];
        const walk = (list: MenuProps['items']) => {
            if (!list) return;
            for (const it of list) {
                if (!it || typeof it !== 'object') continue;
                if ('type' in it && (it as {type?: string}).type === 'divider') continue;
                if ('key' in it && (it as {key?: unknown}).key != null) {
                    const k = String((it as {key: unknown}).key);
                    if (k.startsWith('/')) keys.push(k);
                }
                if ('children' in it && Array.isArray((it as {children?: MenuProps['items']}).children)) {
                    walk((it as {children?: MenuProps['items']}).children);
                }
            }
        };
        walk(visibleChatMenuItems);
        return keys.sort((a, b) => b.length - a.length);
    }, [visibleChatMenuItems]);

    const selectedKey = useMemo(() => {
        if (location.pathname === '/admin' || location.pathname === '/admin/') {
            return '/admin/keyclick';
        }
        const found = chatMenuKeys.find((key) => location.pathname.startsWith(key));
        return found ?? '/admin/keyclick';
    }, [location.pathname, chatMenuKeys]);

    const pageTitle = CHAT_PAGE_TITLES[selectedKey] ?? '后台管理';

    useEffect(() => {
        if (!accountProfileLoading && location.pathname.startsWith('/admin/users') && accountRole !== 'super_admin') {
            navigate('/admin/account', {replace: true});
            return;
        }
        if (!accountProfileLoading && rolePageKeys && location.pathname.startsWith('/admin/') && !rolePageKeys.some(path=>location.pathname.startsWith(path))) {
            navigate('/admin/account', {replace:true});
            return;
        }
        if (visiblePages && location.pathname.startsWith('/admin/') && !location.pathname.startsWith('/admin/users')) {
            const allowed=visiblePages.some(path=>location.pathname.startsWith(path));
            if (!allowed) navigate(chatMenuKeys[chatMenuKeys.length - 1] || '/admin/account', {replace:true});
        }
    }, [accountRole, accountProfileLoading, rolePageKeys, visiblePages, chatMenuKeys, location.pathname, navigate]);

    useEffect(() => {
        document.title = pageTitle || '员工';
    }, [pageTitle]);

    const onMenuNavigate: MenuProps['onClick'] = (e) => {
        navigate(String(e.key));
        setDrawerOpen(false);
    };

    const navigation = (
        <div className="tech-shell-nav">
            <div className="tech-shell-brand">
                <Avatar size={44} style={{backgroundColor: themeColor}}>
                    <MessageOutlined />
                </Avatar>
                {(!collapsed || isMobile) && (
                    <div className="tech-shell-brand-copy">
                        <div className="tech-shell-brand-title">聊天助手 | 后台</div>
                        <Tag color={accountRole==='super_admin'?'purple':accountRole==='admin'?'blue':'default'} style={{marginTop:4,marginInlineEnd:0}}>
                            {accountRole==='super_admin'?'超级管理员':accountRole==='admin'?'管理员':'普通用户'}
                        </Tag>
                    </div>
                )}
            </div>
            <Menu
                mode="inline"
                inlineCollapsed={isMobile ? false : collapsed}
                selectedKeys={[selectedKey]}
                defaultOpenKeys={['sub_commodity']}
                items={nativeContextMenuItems}
                className="tech-shell-menu"
                onClick={onMenuNavigate}
            />
        </div>
    );

    return (
        <>
            <ConfigProvider
                renderEmpty={() => <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="暂无数据"/>}
                theme={{
                    token: {
                        colorPrimary: themeColor,
                    },
                    components: {
                        Menu: {
                            itemMarginInline: 8,
                            itemBorderRadius: 8,
                            itemHeight: 44,
                            iconSize: 18,
                            itemSelectedBg: `${themeColor}1f`,
                            itemSelectedColor: themeColor,
                            itemHoverBg: 'rgba(0, 0, 0, 0.04)',
                            itemActiveBg: `${themeColor}14`,
                            itemColor: 'rgba(0, 0, 0, 0.45)',
                        },
                    },
                }}
            >
                <Layout className="tech-shell-root">
                    {isMobile ? (
                        <Drawer
                            open={drawerOpen}
                            onClose={() => setDrawerOpen(false)}
                            placement="left"
                            width="min(320px, calc(100vw - 24px))"
                            title="导航"
                            className="tech-shell-drawer"
                            styles={{body: {padding: 0}}}
                        >
                            {navigation}
                        </Drawer>
                    ) : (
                        <Sider
                            width={260}
                            collapsedWidth={88}
                            collapsible
                            trigger={null}
                            collapsed={collapsed}
                            onCollapse={setCollapsed}
                            className="tech-shell-sider"
                            theme="light"
                        >
                            {navigation}
                        </Sider>
                    )}

                    <Layout className="tech-shell-body">
                        <Header className="tech-shell-header">
                            <div className="tech-shell-header-main">
                                <Button
                                    type="text"
                                    className="tech-shell-trigger"
                                    icon={
                                        isMobile ? (
                                            <MenuUnfoldOutlined/>
                                        ) : collapsed ? (
                                            <MenuUnfoldOutlined/>
                                        ) : (
                                            <MenuFoldOutlined/>
                                        )
                                    }
                                    onClick={() => {
                                        if (isMobile) {
                                            setDrawerOpen(true);
                                            return;
                                        }
                                        setCollapsed((v: boolean) => !v);
                                    }}
                                />
                                <div className="tech-shell-headline">
                                    <Typography.Title level={4} className="tech-shell-title">
                                        {pageTitle}
                                    </Typography.Title>
                                </div>
                            </div>

                            <div className="tech-shell-header-meta">
                                <Dropdown
                                    trigger={['click']}
                                    menu={{items: [
                                        {key: '#7c3aed', label: '紫色'},
                                        {key: '#1677ff', label: '蓝色'},
                                        {key: '#08979c', label: '青色'},
                                        {key: '#389e0d', label: '绿色'},
                                        {key: '#d46b08', label: '橙色'},
                                    ], onClick: ({key}) => changeThemeColor(String(key))}}
                                >
                                    <Button type="text" icon={<BgColorsOutlined/>}>配色</Button>
                                </Dropdown>
                                {!screens.sm ? null : <Tag color={accountRole === 'super_admin' ? 'purple' : themeColor}>{accountRole === 'super_admin' ? '超级管理员' : accountRole === 'admin' ? '管理员' : '普通用户'}</Tag>}
                                <Dropdown menu={{items: accountDropdownItems}} trigger={['click']} placement="bottomRight">
                                    <Button type="text" className="tech-shell-account">
                                        <Space size={10}>
                                            <Avatar size={34} style={{backgroundColor: themeColor}}>
                                                <UserOutlined />
                                            </Avatar>
                                            {!isMobile && <span>{accountRole === 'super_admin' ? '超级管理员' : '账号'}</span>}
                                        </Space>
                                    </Button>
                                </Dropdown>
                            </div>
                        </Header>

                        <Content className="tech-shell-content">
                            <Watermark inherit content={use_message_return.user_oname}>
                                <div className="tech-shell-page">
                                    <Outlet/>
                                </div>
                            </Watermark>
                        </Content>
                    </Layout>
                </Layout>
            </ConfigProvider>


            <Modal open={show_myvip_modal_open} onCancel={setshow_myvip_modal_oncancel} width={1000} footer={null} >
                <div style={{display:'flex',flexDirection:'column',width:'100%',overflowY:'auto'}}>

                    <div style={{display:'flex',flexDirection:'column'}}>

                        <label style={{fontSize:15,fontWeight:'bold'}}>当前状态</label>


                        {return_data_fetch_vipinfo.is_dt ===0 ?<label style={{marginTop:12}}>会员信息：未开通</label>: <>
                            <label style={{marginTop:12}}>会员信息：{return_data_fetch_vipinfo.info.type}</label>

                            <label>有效期至：{dayjs.unix(return_data_fetch_vipinfo.info.vip_end_time).format('YYYY-MM-DD')}</label>

                        </>}


                    </div>

                    <Tabs items={[{key:'1',label:'购买/续费',children:     <div style={{display:'flex',width:'100%',overflowY:'auto'}}>
                            <Card style={{}}>








                                <div style={{display:'flex',flexDirection:'column'}}>
                                    <label style={{fontSize:15,fontWeight:'bold'}}>购买</label>
                                    <Select value={purchaseDuration} style={{width:220,marginTop:12}} options={[{value:'1m',label:'1个月'},{value:'6m',label:'6个月'},{value:'1y',label:'1年'},{value:'permanent',label:'永久'}]} onChange={(duration)=>{setPurchaseDuration(duration);const product=return_data_get_products.info.find((item:any)=>productMatchesDuration(item,duration));if(product)buy_onchange(product.uuid)}}/>

                                    <div style={{ display: 'flex',marginTop:20}}>

                                        <Space >

                                            {return_data_get_products.message!==2000?<></>:return_data_get_products.info.filter((item:any)=>productMatchesDuration(item,purchaseDuration)).map((item1:any)=>(

                                                <Card size={'small'}
                                                      hoverable
                                                      style={{ width: 180 }}
                                                    /*     onMouseEnter={() => setValue(100)}*/
                                                      onClick={() => buy_onchange(item1.uuid)}
                                                      className={value === item1.uuid ? 'active-card' : ''}
                                                >
                                                    <div style={{display:'flex',flexDirection:'column'}}>


                                                        <label style={{color:value === item1.uuid?'#1890ff':''}}>
                                                            {item1.value}
                                                        </label>

                                                        <label>{item1.market_price!==null?<div><label style={{color:value === item1.uuid?'#1890ff':''}}>¥ <label style={{fontSize:23,fontWeight:'bold'}}>{item1.market_price}</label></label> <label style={{ color:value === item1.uuid?'#1890ff':'',textDecoration: 'line-through',marginLeft:5 }}>¥ {item1.price}</label></div>:            <label style={{color:value === item1.uuid?'#1890ff':''}}>¥ <label style={{fontSize:23,fontWeight:'bold'}}>{item1.price}</label></label>
                                                        }</label>


                                                    </div>

                                                </Card>
                                            ))}



                                        </Space>

                                    </div>





                                </div>

                                <div style={{display:'flex',flexDirection:'column',marginTop:20}}>

                                    <label style={{fontSize:15,fontWeight:'bold'}}>支付方式</label>


                                    <div style={{ display: 'flex',marginTop:20}}>

                                        <Radio.Group defaultValue={'alipay'} onChange={(e)=>pay_type_onchange(e)}>

                                            {/*     <Radio value="wxpay">微信支付</Radio>*/}
                                            <Radio value="alipay">支付宝支付</Radio>

                                        </Radio.Group>
                                    </div>


                                </div>
                                <div style={{display:'flex',flexDirection:'column',marginTop:20}}>

                                    <label style={{fontSize:15,fontWeight:'bold'}}>您选择的方</label>


                                    {return_data_fetch_select_price_info.message!==2000?<></>:<>







                                        <label style={{marginTop:10}}>价格： <label>{return_data_fetch_select_price_info.info.market_price!==null?<label >¥ <label style={{}}>{return_data_fetch_select_price_info.info.market_price}/{return_data_fetch_select_price_info.info.value}</label></label>:            <label style={{}}>¥ <label style={{}}>{return_data_fetch_select_price_info.info.price}/{return_data_fetch_select_price_info.info.value}</label></label>
                                        }</label> </label>


                                        <label style={{marginTop:10}}>到期时间：{dayjs.unix(return_data_fetch_select_price_info.info.buy_vip_end_time).format('YYYY-MM-DD')}</label>

                                    </>}

                                    <Divider/>


                                    <label style={{marginTop:10}}>订单金额： <label>{return_data_fetch_select_price_info.info.market_price!==null?<label style={{fontSize:18,fontWeight:'bold'}}>¥<label style={{fontSize:23,fontWeight:'bold'}}>{return_data_fetch_select_price_info.info.market_price}</label></label>:            <label style={{fontSize:18,fontWeight:'bold'}}>¥<label style={{fontSize:23,fontWeight:'bold'}}>{return_data_fetch_select_price_info.info.price}</label></label>
                                    }</label></label>

                                    <Button style={{marginTop:10}} onClick={()=>buy_phone_pay('','','')}>确认付款</Button>

                                    <div style={{display:'flex',padding:10}}>
                                        <Checkbox defaultChecked={checkbox_buy} onChange={(e)=>setcheckbox_buy(e.target.checked)}></Checkbox>
                                        <label style={{marginLeft:10}}>同意并接受聊天助手付费版服务协议和聊天助手隐私政策
                                            *含自动续费条款</label>

                                    </div>

                                </div>
                            </Card>


                            <Card style={{marginLeft:10}}>


                                <div style={{display:'flex',flexDirection:'column',width:150}}>

                                    <label style={{fontSize:15,fontWeight:'bold'}}>vip权益</label>

                                    <label style={{marginTop:10}}> 1、无限制创建分组</label>
                                    <label style={{marginTop:10}}> 2、无限制创建商品</label>
                                    <label style={{marginTop:10}}> 3、无话术添加限制</label>
                                    <label style={{marginTop:10}}> 4、无限制子账号</label>
                                </div>

                            </Card>

                        </div>},{key:'2',label:'兑换vip',children: <div style={{display:'flex',alignContent:'center',justifyContent:'center',width:'100%',overflowY:'auto'}}>




                            <Card style={{width:'100%'}}>




                                <label>会员兑换</label>





                                <Input ref={inputRef} style={{marginTop:20}} onPressEnter={VipRedemption_check_card} placeholder="请输入会员卡密">


                                </Input>



                                <Space style={{marginTop:20}}>
                                    <Button type={'primary'} onClick={VipRedemption_check_card}>兑换</Button>

                                    <Button onClick={check_card_info}>查询时长</Button>


                                </Space>



                            </Card>


                        </div>


                    }]}>



                    </Tabs>


                </div>


                <Modal open={check_card_info_modal_open} onCancel={setcheck_card_info_modal_oncancel} footer={null} title={'cdk信息'}>

                    {return_data_check_card_info.message!==2000?<></>:<div>{return_data_check_card_info.info.card_use?<div>{return_data_check_card_info.info.tips}</div>:<div style={{display:'flex',flexDirection:'column'}}>


                        <label>vip天数：{return_data_check_card_info.info.vipday}天</label>
                        <label>卡片有效期：{return_data_check_card_info.info.card_end_time}</label>

                    </div>}</div>}


                    {/*  <Button style={{marginLeft:10}} onClick={setcheck_card_info_modal_oncancel}>

                    取消
                </Button>
*/}

                </Modal>




                <Modal open={VipRedemption_modal_open} onCancel={setVipRedemption_modal_oncancel} footer={null} title={'是否确认兑换？'}>


                    <Button type={'primary'} onClick={VipRedemption_modal_next_button}>

                        确认兑换
                    </Button>


                    <Button style={{marginLeft:10}} onClick={setVipRedemption_modal_oncancel}>

                        取消
                    </Button>


                </Modal>

                <Modal open={pay_model_modal_open} onCancel={setpay_model_modal_oncancel} footer={null} title={'订单是否已支付？'}>



                    <Space>
                        <Button type={'primary'} onClick={pay_model_modal_next_button}>

                            已支付
                        </Button>


                        <Button  onClick={pay_model_modal_next_button} >

                            未支付
                        </Button>


                    </Space>


                </Modal>


            </Modal>






            <Modal open={myuserinfo_modal_open} onCancel={setmyuserinfo_modal_oncancel} footer={null} title={'个人信息'}>



                <div style={{display:'flex',flexDirection:'column'}}>



                    <label>用户名：{return_data_fetch_userinfo.info.user_name}</label>


                    <label>公司名称：{return_data_fetch_userinfo.info.country_info.country_name}</label>

                </div>


            </Modal>



        </>


    )
}


export default Admin_Index_UI;
